// extracted by mini-css-extract-plugin
export var box = "_5m-1";
export var checkboxRow = "_5m-8";
export var checked = "_5m-2";
export var descriptionSpacer = "_5m-a";
export var disabled = "_5m-3";
export var icon = "_5m-6";
export var input = "_5m-0";
export var labelSpacer = "_5m-9";
export var medium = "_5m-5";
export var small = "_5m-4";
export var text = "_5m-7";